import {
  IconButton as MuiIconButton,
  IconButtonProps as MuiIconButtonProps,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const PaginationIconButton = styled(MuiIconButton)<MuiIconButtonProps>(
  ({ theme: { palette, spacing } }) => ({
    margin: spacing(0, 0.5),
    padding: spacing(0.6),
    color: palette.text.primary,

    '&:first-of-type': {
      marginLeft: '0',
    },

    '&:last-of-type': {
      marginRight: '0',
    },
  })
);
